import { ApiResponse } from '../models/apiResponse';
import { apiRequests as requests } from './http-client';

interface ErrorLogRequest {
  message: string;
  url: string;
  api?: string;
}

const ErrorTracking = {
  trackError: (
    error: string,
    stack: string | null | undefined,
    url: string
  ) => {
    const message = `${error}\nCall Stack: ${stack}`;

    const request: ErrorLogRequest = {
      message,
      url,
    };

    return requests.post<ApiResponse>('/v1/logs', request);
  },
};

export default ErrorTracking;
